import { useState, useCallback } from 'react';
import quarkusApi from '../../../../../api/quarkusApi';

export function useSaveProcedure(treatmentId) {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback(
    (procedure) => {
      setSaving(true);
      return quarkusApi
        .post(`/v2/treatments/${treatmentId}/procedures`, procedure, {
          headers: { Authorization: sessionStorage.getItem('token') },
        })
        .finally(() => setSaving(false));
    },
    [treatmentId],
  );

  return { save, isSaving };
}
